import { render, staticRenderFns } from "./Gadgetnotification.vue?vue&type=template&id=526a5966&scoped=true"
import script from "./Gadgetnotification.vue?vue&type=script&lang=js"
export * from "./Gadgetnotification.vue?vue&type=script&lang=js"
import style0 from "./Gadgetnotification.vue?vue&type=style&index=0&id=526a5966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a5966",
  null
  
)

export default component.exports